import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../service/common/settings.service';
import { SettingsListService } from '../../service/main/settings-list.service';

@Component({
  selector: 'app-settings-list',
  templateUrl: './settings-list.component.html',
  styleUrls: ['./settings-list.component.css']
})
export class SettingsListComponent implements OnInit {

  isEdit: Array<boolean>;

  settings: Array<any>;

  settingsHeader: boolean = false;

  constructor(
    private setting: SettingsService,
    private settingsList: SettingsListService
  ) { }

  ngOnInit() {
    this.settingsList.getAllSettings().subscribe(data => {
      const edits = [];
      const settingsList = [];
      data.forEach(setting => {
        settingsList.push({
          name: setting.code,
          settingID: setting.settingID,
          dynamicTypeID: setting.dynamicTypeID,
          details: setting.description,
          value: setting.dynamicTypeID === 1 ? setting.int32Val : 
                 setting.dynamicTypeID === 2 ? setting.decimalVal : 
                 setting.dynamicTypeID === 3 ? setting.dateTimeVal :
                 setting.dynamicTypeID === 4 ? setting.booleanVal :
                 setting.dynamicTypeID === 5 ? setting.stringVal : 
                 setting.dynamicTypeID === 6 ? setting.int64Val :
                 setting.dynamicTypeID === 7 ? setting.listVal : 
                 null,
        });
        edits.push(false);
      });
      this.settings = settingsList;
      this.isEdit = edits;
      if(this.settings.length) {
        this.settingsHeader = true;
      }
    });
    
    
  }

  editSettings(value, name, i) {
    const edit = {
      settingID: this.settings[i].settingID,
      dynamicTypeID: this.settings[i].dynamicTypeID,
      int32Val: this.settings[i].dynamicTypeID === 1 ? value : null,
      decimalVal: this.settings[i].dynamicTypeID === 2 ? value : null,
      dateTimeVal: this.settings[i].dynamicTypeID === 3 ? value : null,
      booleanVal: this.settings[i].dynamicTypeID === 4 ? value : null,
      stringVal: this.settings[i].dynamicTypeID === 5 ? value : null,
      int64Val: this.settings[i].dynamicTypeID === 6 ? value : null,
      code: name,
      description: this.settings[i].details,
    }
    this.isEdit[i] = false;
    this.settingsList.editSetting(edit).subscribe();
  }

}
